<template>
    <v-card width="620" class="mx-auto" :loading="loading" :disabled="loading">
      <v-card-title>
        ข้อมูลจำนวนนักศึกษาระดับปริญญาตรีที่มีสถานะเรียนทั้งหมด
      </v-card-title>
      <!-- <v-card-subtitle>(ตั้งแต่ปีการศึกษา 2566 เป็นต้นไป)</v-card-subtitle> -->
      <v-card-text>
        <v-autocomplete
          v-model="selected_year"
          v-bind:label="'รหัสนักศึกษา'"
          v-bind:items="years"
          v-bind:item-value="(item) => item"
          v-bind:item-title="(item) => item"
          outlined
        ></v-autocomplete>
  
        <v-btn color="green darken-3" class="white--text" @click="download()">
          ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  import ReportProvider from "@/services/report.provider.js";
  const ReportService = new ReportProvider();
  import { studentStudyExcel } from "./generate.js";
  
  export default {
    name: "ReportStudent",
  
    data: () => ({
      loading: false,
      years: ['ทั้งหมด', '69', '68', '67', '66', '65', '64', '63', '62', '61', '60', '59', '58'],
      selected_year: 'ทั้งหมด',
      selected_month: null,
    }),
  
    methods: {
      studentStudyExcel,
  
    //   async getYears() {
    //     const data = new Date().getFullYear() + 543;
    //     this.years = [data, data - 1, data - 2];
    //   },
  
      async download() {
        this.loading = true;
        const data = await ReportService.getReportStudentStudy(
          this.selected_year, this.selected_month
        ).catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
        if (data['total'] == 0) {
          this.$toasted.error('ไม่พบข้อมูลนักศึกษา', {
            duration: 3000,
          });
        } else {
          studentStudyExcel(data['res'], 'ปริญญาตรี', this.selected_year);
          this.$toasted.success('ดาวน์โหลดข้อมูลนักศึกษาเรียบร้อยแล้ว', {
            duration: 3000,
          });
        }
        this.loading = false;
      },
    },
  
    // created() {
    //   this.getYears();
    // },
  };
  </script>
  